module.exports = __webpack_public_path__ + "static/media/Pomp_Schema.8055e0eb.jpg";